import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { editReportVersionDeliverableFileRoute, reportVersionDeliverableFilesRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { UpdateReportDeliverableFileForm } from "app/component/report-deliverable-file/UpdateReportDeliverableFileForm.tsx";

export const EditReportVersionDeliverableFileScreen: FC = () => {
    const { reportId, versionId, fileId } = useRouteParams(editReportVersionDeliverableFileRoute);
    const [created, setUpdated] = useState(false);

    return created ? (
        <Navigate to={reportVersionDeliverableFilesRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={editReportVersionDeliverableFileRoute} />
                <UpdateReportDeliverableFileForm fileId={fileId} onUpdate={() => setUpdated(true)} />
            </Container>
        </NavigationScreen>
    );
};
